import { FilterValue } from "../Filters/FilterValue";

export const ShipmentModes: FilterValue[] = [
  { id: "0", value: "" },
  { id: "1", value: "Air" },
  { id: "2", value: "Surface" },
  { id: "3", value: "Hybrid" },
];
